/* Gold/silver twins shown as one card (snippets/ee-pair-card.liquid). Tapping the other finish's dot swaps the card to
   that product without leaving the page; tapping the dot of the finish already showing opens that product. On a
   product page, the design's own card is also taken out of the "You may also like" row, which loads after the page. */
(function () {
  if (window.eeFinishInit) return;
  window.eeFinishInit = true;
  document.addEventListener('click', function (e) {
    var dot = e.target.closest ? e.target.closest('[data-ee-finish]') : null;
    if (!dot) return;
    var pair = dot.closest('[data-ee-pair]');
    if (!pair) return;
    var finish = dot.getAttribute('data-ee-finish');
    var target = pair.querySelector('[data-ee-finish-card="' + finish + '"]');
    if (!target || !target.hidden) return;
    e.preventDefault();
    pair.querySelectorAll('[data-ee-finish-card]').forEach(function (card) { card.hidden = card !== target; });
    var same = target.querySelector('[data-ee-finish="' + finish + '"]');
    if (same) same.focus({ preventScroll: true });
  });
  var me = window.eeProductHandle;
  if (!me) return;
  function strip(root) {
    root.querySelectorAll('[data-ee-pair]').forEach(function (p) {
      if (('|' + p.getAttribute('data-ee-pair') + '|').indexOf('|' + me + '|') > -1) {
        var cell = p.closest('li') || p;
        cell.parentNode && cell.parentNode.removeChild(cell);
      }
    });
  }
  function watch() {
    document.querySelectorAll('product-recommendations').forEach(function (r) {
      strip(r);
      new MutationObserver(function () { strip(r); }).observe(r, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();